import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const scrollToId = (id) => {
  const target = document.getElementById(id);
  if (!target) return;
  if (window.__lenis) window.__lenis.scrollTo(target, { offset: -72 });
  else target.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, overline, title, note }) => (
  <Reveal className="mb-12 md:mb-16">
    <div className="flex items-baseline gap-4">
      {index && (
        <span className="font-mono text-sm text-[#FF5500]" data-testid={`section-index-${index}`}>
          {index}
        </span>
      )}
      <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#FF5500]">
        {overline}
      </p>
    </div>
    <div className="mt-4 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <h2 className="font-display max-w-2xl text-2xl font-semibold uppercase tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      {note && <p className="max-w-sm text-sm leading-relaxed text-slate-400 md:text-right">{note}</p>}
    </div>
  </Reveal>
);
